import React from 'react';

import classNames from 'classnames';

import classes from './GrossRevenueSummaryItem.module.scss';
import { getNumberWithSignView } from '../../../../../../shared/utils/stringUtils/getNumberWithSignView/getNumberWithSignView';
import { getPriceView } from '../../../../../../shared/utils/stringUtils';

type IndicatorColor = 'green' | 'gray';

type GrossRevenueSummaryItemProps = {
  title: string;
  indicatorColor: IndicatorColor;
  value: number;
  diffPercent?: number;
  period?: string;
};

const GrossRevenueSummaryItem = ({
  title,
  value,
  diffPercent,
  period,
  indicatorColor,
}: GrossRevenueSummaryItemProps) => {
  const diffPercentClass = classNames(classes.diffPercent, {
    [classes.positive]: diffPercent && diffPercent > 0,
    [classes.negative]: diffPercent && diffPercent < 0,
  });

  const indicatorClass = classNames(classes.indicator, classes[indicatorColor]);

  return (
    <div className={classes.container}>
      <div className={classes.titleRow}>
        <div className={indicatorClass} />
        <span className={classes.title}>{title}</span>
      </div>
      <div className={classes.valueBlock}>
        <p className={classes.value}>{getPriceView(value / 100)}</p>
        {!!diffPercent && (
          <div className={classes.comparingRow}>
            <span className={diffPercentClass}>
              {getNumberWithSignView(diffPercent, 2)}%
            </span>
            {period && <span className={classes.period}>vs {period}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export { GrossRevenueSummaryItem };
